/**
 * Light / dark.
 *
 * Three-way, not two: "system" is the default and follows the machine. Someone whose
 * laptop switches to dark at sunset should not have to come here and do it again.
 *
 * The choice is stored per browser rather than per account, on purpose. The same person
 * may be on a wall display in a bright control room and a laptop at home at 2am, and
 * those want opposite answers.
 */

const KEY = 'imtlogic.theme';
export const MODES = ['system', 'light', 'dark'];

const media = () => window.matchMedia('(prefers-color-scheme: dark)');

export function storedMode() {
  const v = localStorage.getItem(KEY);
  return MODES.includes(v) ? v : 'system';
}

export function resolve(mode) {
  if (mode === 'light' || mode === 'dark') return mode;
  return media().matches ? 'dark' : 'light';
}

export function apply(mode) {
  const theme = resolve(mode);
  document.documentElement.setAttribute('data-theme', theme);
  // Tells the browser to match its own furniture — scrollbars, form controls, the
  // flash of background before paint. Without it a light page keeps dark scrollbars.
  document.documentElement.style.colorScheme = theme;
  return theme;
}

export function setMode(mode) {
  if (!MODES.includes(mode)) mode = 'system';
  if (mode === 'system') localStorage.removeItem(KEY);
  else localStorage.setItem(KEY, mode);
  return apply(mode);
}

/** Follow the machine while the mode is "system". Returns an unsubscribe function. */
export function watchSystem(onChange) {
  const m = media();
  const handler = () => {
    if (storedMode() === 'system') onChange(apply('system'));
  };
  m.addEventListener('change', handler);
  return () => m.removeEventListener('change', handler);
}
